import BaseModal from './BaseModal';

class FullscreenModal extends BaseModal {
  constructor(
    contentProvider,
    settings = {
      display_before_content_load: false,
    },
  ) {
    super(
      {
        overlay: document.querySelector('.js-modal-overlay-fs'),
        modal_window: document.querySelector('.js-modal-window-fs'),
        modal_content: document.querySelector('.js-modal-content-fs'),
        close_button: document.querySelector('.js-modal-close-fs'),
      },
      contentProvider,
      settings
    );
  }
}

export default FullscreenModal;



// WEBPACK FOOTER //
// ./src/js/modals/FullscreenModal.js